import React, { useState, useEffect } from 'react';
import { useAdminApi } from '../../api/adminApi';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
  IconButton,
} from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { AlertColor } from '@mui/material/Alert';

export const RolesPage = () => {
  const { getAllRoles, deleteRole, createRole } = useAdminApi(); // createRole eklendi
  const [roles, setRoles] = useState<string[]>([]);
  const [newRoleName, setNewRoleName] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: AlertColor;
  }>({ open: false, message: '', severity: 'success' });

  const loadRoles = async () => {
    const response = await getAllRoles();
    if (response.data) {
      setRoles(response.data.data);
    }
  };

  useEffect(() => {
    loadRoles();
  }, []);

  const handleDeleteRole = async (roleName: string) => {
    try {
      await deleteRole(roleName);
      setSnackbar({ open: true, message: 'Rol başarıyla silindi!', severity: 'success' });
      loadRoles();
    } catch (error) {
      setSnackbar({ open: true, message: 'Rol silinirken hata oluştu!', severity: 'error' });
    }
  };

  const handleAddRole = async () => {
    try {
      if (!newRoleName.trim()) {
        setSnackbar({ open: true, message: 'Rol adı boş olamaz!', severity: 'warning' });
        return;
      }

      const response = await createRole(newRoleName);
      if (response.data) {
        setSnackbar({ open: true, message: 'Rol başarıyla eklendi!', severity: 'success' });
        loadRoles();
        setOpenDialog(false);
        setNewRoleName('');
      }
    } catch (error) {
      setSnackbar({ open: true, message: 'Rol eklenirken hata oluştu!', severity: 'error' });
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Rol Yönetimi</Typography>
      
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => setOpenDialog(true)}
        sx={{ mb: 3 }}
      >
        Yeni Rol Ekle
      </Button>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Rol Adı</TableCell>
              <TableCell align="right">İşlemler</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {roles.map((role) => (
              <TableRow key={role}>
                <TableCell>{role}</TableCell>
                <TableCell align="right">
                  <IconButton onClick={() => handleDeleteRole(role)} color="error">
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Yeni Rol Ekle</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Rol Adı"
            fullWidth
            value={newRoleName}
            onChange={(e) => setNewRoleName(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleAddRole()}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>İptal</Button>
          <Button onClick={handleAddRole} color="primary" disabled={!newRoleName.trim()}>
            Ekle
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
};